export enum UrlVariable {
  Ec1StartYourBusinessUrl = '#ec1StartYourBusinessUrl#',
}
